<template>
    <Dialog :visible.sync="isOpen" :show-header="false" :modal="true" class="lightbox-dialog">
        <div
            v-if="isOpen"
            class="swiper-container z-50 fixed top-0 left-0 w-full h-screen pt-16 pb-12 sm:py-12 overflow-auto dark"
        >
            <Button btn-close class="absolute top-4 right-4" :aria-label="$t('generic.close')" @click.native="close" />
            <div class="container relative max-h-screen bg-theme-dark bg-theme-dark--swiper z-1">
                <div id="lightbox" class="swiper swiper--lightbox">
                    <div class="swiper-wrapper relative">
                        <div
                            v-for="(item, i) in items"
                            :key="`gallery-image-${i}`"
                            class="swiper-slide flex items-center justify-center"
                        >
                            <img
                                class="max-h-full max-w-full sm:rounded-4xl"
                                :src="item.src"
                                :alt="`${$t('generic.gallery_image_alt_text')} ${i}`"
                            />
                        </div>
                    </div>

                    <div class="flex flex-col-reverse sm:flex-col">
                        <div
                            class="carousel-pagination-block container relative mt-6 sm:mt-8 grid grid-cols-12 base-responsive-gap"
                        >
                            <nav
                                class="col-span-12 xl:col-span-10 xl:col-start-2 2xl:col-span-12 2xl:col-start-1 flex items-center justify-center"
                                :aria-label="$t('a11y.gallery_stepper')"
                            >
                                <button ref="prevBtn" class="swiper-button-prev"></button>
                                <span class="gallery-pagination-counter">01</span>
                                <div ref="pagination" class="swiper-pagination"></div>
                                <span class="gallery-pagination-counter">{{
                                    String(items.length).padStart(2, '0')
                                }}</span>
                                <button ref="nextBtn" class="swiper-button-next"></button>
                            </nav>
                        </div>
                    </div>

                    <SwiperNavigationButton prev @click.native="prev" />
                    <SwiperNavigationButton next autofocus @click.native="next" />
                </div>

                <div
                    v-if="items[activeSlideIndex].title || items[activeSlideIndex].description"
                    class="text-white pt-4 text-center"
                >
                    <h3 v-if="items[activeSlideIndex].title" class="font-bold mb-1">
                        {{ items[activeSlideIndex].title }}
                    </h3>
                    <p v-if="items[activeSlideIndex].description">{{ items[activeSlideIndex].description }}</p>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import SwiperNavigationButton from '@/components/UI/SwiperNavigationButton.vue';

export default {
    name: 'XXLGalleryCarousel',
    components: {
        SwiperNavigationButton,
        Dialog,
    },
    data() {
        return {
            items: [],
            isOpen: false,
            activeSlideIndex: 0,
            carousel: null,
        };
    },
    watch: {
        isOpen(value) {
            if (value) {
                console.log('init carousel');
                setTimeout(() => {
                    this.carousel = new this.$swiper(document.getElementById('lightbox'), {
                        spaceBetween: 16,
                        slidesPerView: 1,
                        centeredSlides: true,
                        initialSlide: this.activeSlideIndex,
                        loop: true,
                        navigation: {
                            nextEl: this.$refs.nextBtn,
                            prevEl: this.$refs.prevBtn,
                        },
                        keyboard: {
                            enabled: true,
                        },
                        pagination: {
                            el: this.$refs.pagination,
                            clickable: true,
                            bulletElement: 'button',
                        },
                        a11y: {
                            containerMessage: this.$t('carousel.a11y.container_message_gallery'),
                            paginationBulletMessage: this.$t('carousel.a11y.pagination_bullet_message'),
                            firstSlideMessage: this.$t('carousel.a11y.first_slide_message'),
                            lastSlideMessage: this.$t('carousel.a11y.last_slide_message'),
                            nextSlideMessage: this.$t('carousel.a11y.next_slide_message'),
                            prevSlideMessage: this.$t('carousel.a11y.prev_slide_message'),
                        },
                    });

                    this.carousel.on('slideChange', () => {
                        this.activeSlideIndex = this.carousel.realIndex;
                    });
                }, 50);
            } else {
                this.carousel.destroy();
                this.carousel = null;
            }
        },
    },
    created() {
        this.$nuxt.$on('open-lightbox', (payload) => {
            this.activeSlideIndex = payload.index || 0;
            this.items = payload.items;
            this.isOpen = true;
        });
    },
    methods: {
        close() {
            this.isOpen = false;
        },
        prev() {
            this.carousel.slidePrev();
        },
        next() {
            this.carousel.slideNext();
        },
    },
};
</script>

<style>
.swiper.swiper--lightbox .swiper-slide {
    @apply h-[calc(100vh-350px)] min-h-[200px] sm:h-[calc(100vh-270px)] sm:min-h-[300px] 2xl:h-[calc(100vh-270px)] 2xl:min-h-[400px];
}

/*

.gallery-thumbnails .swiper-slide {
    @apply opacity-80;
}
#gallery {
    @apply mb-[30px];

    .swiper-slide {
        @apply aspect-w-16 aspect-h-9;

        img {
            @apply object-cover;
        }
    }
}

#gallery-thumbnails {
    .swiper-slide {
        img {
            @apply object-cover;
        }
    }
}

*/
</style>
